<template>
  <div class="app-body" ref="appContent">
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :xl="8" :lg="8" :md="8">
          <el-form-item label="外销合同编号：" prop="agreementCode">
            <order-drop v-model="dataForm.agreementCode" placeholder="请输入外销合同编号"
                        @change="agreementCodeChange"></order-drop>
          </el-form-item>
        </el-col>
      </el-row>

      <el-card>
        <div slot="header" class="card-header">
          <div>采购明细</div>
        </div>
        <SweetTable ref="table" :data="dataForm.detailList" :height="maxTableHeight">
          <el-table-column label="品名" prop="product.name" align="center">
          </el-table-column>
          <el-table-column
              label="颜色"
              prop="product.color"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              label="规格"
              prop="product.size"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              label="幅宽"
              prop="product.attr1"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              label="克重"
              prop="product.attr2"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              label="采购数量"
              header-align="center"
              align="center"
              width="130"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.count'"
                  :rules="detailRule.count"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input v-model="scope.row.count" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="采购单价"
              header-align="center"
              align="center"
              width="130"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.amount'"
                  :rules="detailRule.amount"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-input v-model="scope.row.amount" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="供应商"
              header-align="center"
              align="center"
              width="230"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.companyId'"
                  :rules="detailRule.companyId"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-select size="mini" v-model="scope.row.companyId" style="width: 100%" :filterable="true">
                  <el-option v-for="item in companyList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
              label="收货工厂"
              header-align="center"
              align="center"
              min-width="230"
          >
            <template slot-scope="scope">
              <el-form-item
                  :prop="'detailList.' + scope.$index + '.storageId'"
                  :rules="detailRule.storageId"
                  label-width="0"
                  style="margin-top: 20px"
              >
                <el-select size="mini" v-model="scope.row.storageId" style="width: 100%" :filterable="true">
                  <el-option v-for="item in storageList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  icon="el-icon-remove"
                  size="mini"
                  @click="delRow(scope.$index, scope.row, 'detailList')"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </SweetTable>
      </el-card>
    </el-form>
    <div class="footer">
      <el-button @click="cancel()">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import SingleFileUpload from '@/components/SingleFileUpload'
import { isNumber, moneyValidator } from '@/utils/validate'

export default {
  components: { SingleFileUpload },
  data () {
    return {
      agreementId: '',
      id: '',
      dataForm: {},
      type: 'single',
      maxTableHeight: 100,
      storageList: [],
      companyList: []
    }
  },
  computed: {
    codeCanEdit () {
      if (this.agreementId) {
        return false
      }
      return true
    },
    dataRule () {
      return {
        agreementCode: [
          { required: true, message: '请输入外销合同号', trigger: 'change' },
        ],

      }
    },
    detailRule () {
      return {
        productName: [
          { required: true, message: '请填写名称', trigger: 'change' },
        ],
        amount: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        companyId: [
          { required: false, message: '请选择供应商', trigger: 'change' },
        ],
        storageId: [
          { required: false, message: '请选择收货仓库', trigger: 'change' },
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
  },
  mounted () {

  },
  activated () {
    this.queryCompanyList()
    this.queryStorageList()
    this.reset()
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    let tmpList = JSON.parse(window.localStorage.getItem('purchase_copy_data'))
    tmpList.forEach((row, index) => {
      row.id = index

    })
    this.dataForm.detailList = tmpList.map((item) => {
      return {
        id: item.id,
        productId: item.productId,
        product: item.product,
        count: item.count,
        amount: item.amount,
        companyId: item.companyId,
        storageId: item.storageId
      }
    })
    this.$nextTick(() => {
      this.maxTableHeight =
          this.$refs.appContent.clientHeight -
          240
    })
  },
  methods: {
    async queryCompanyList () {
      const { data: res } = await this.$http.get(`/trade/company/list`)
      this.companyList = res.data
    },
    async queryStorageList () {
      const { data: res } = await this.$http.get(`/trade/storages/list`)
      this.storageList = res.data
    },
    async agreementCodeChange (orderCode) {
      if (orderCode.indexOf('/') > -1) {
        orderCode = orderCode.replace('/', '$-$')
      }
      let loading = this.$loading()
      try {
        const { data: res } = await this.$http
            .get(`/trade/agreement/code/${orderCode}`)
        if (res.data) {
          this.dataForm.agreementId = res.data.id
        } else {
          this.dataForm.agreementId = ''
        }
      } catch (e) {
        console.log(e)
      }
      loading.close()
    },
    delRow (index, row, dataKey) {
      this.dataForm.detailList.splice(index, 1)
    },
    reset () {
      this.dataForm = {
        id: '',
        remark: '',
        totalAmount: '',
        code: '',
        customerId: '',
        agreementCode: '',
        agreementId: '',
        detailList: [],
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].clearValidate()
      }
    },

    cancel () {
      this.$router.back()
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }

            if (this.dataForm.detailList.length === 0) {
              return this.$message.error('原料明细不能为空')
            }
            let postForm = []
            this.dataForm.detailList.forEach((item) => {
              console.log(item)
              if (!item.storageId || !item.companyId || !item.count || item.count == 0) {
                return
              }
              postForm.push({
                ...item,
                id: '',
                agreementId: this.dataForm.agreementId,
              })
            })
            const loading = this.$loading()
            this.$http
                .post('/trade/purchase/save', postForm)
                .then(({ data: res }) => {
                  loading.close()
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.$router.back()
                    },
                  })
                })
                .catch((e) => {
                  console.log(e)
                  loading.close()
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>
